import axios from 'axios';
import * as actionTypes from './Actiontypes';

const BASE_URL = "https://api.happiclips.com/api"

export const get_email = (payload) => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.GET_EMAIL_CONGIF_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/email-config/get-by-user`, payload,{
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });

            dispatch({
                type: actionTypes.GET_EMAIL_CONGIF_SUCCESS,
                payload: res.data,
                
            })
            // console.log(res.data)
        }
        catch (error) {
            dispatch({
                type: actionTypes.GET_EMAIL_CONGIF_FAIL,
                payload: error
            })
          
        }
    }
}

export const create_email = (email_type_id,subject,message,regards) => {
    return async (dispatch) => {
        const payload={
            email_type_id,
            subject,
            message,
            regards
        }
        dispatch({
            type: actionTypes.CREATE_EMAIL_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/email-config/save`, payload,{
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            
            dispatch({ 
                type: actionTypes.CREATE_EMAIL_SUCCESS,
                payload: res.data,
                
            })
            // console.log(res.data)
        }
        catch (error) {
            dispatch({
                type: actionTypes.CREATE_EMAIL_FAIL,
                payload: error
            })
          
        }
    }
}